import { useSyncExternalStore } from 'react';

// App-wide overlays that any screen can open.
export interface UiState {
  auth: { mode: 'signup' | 'login'; reason?: string } | null;
  settings: boolean;
}

let state: UiState = { auth: null, settings: false };
const listeners = new Set<() => void>();
const set = (patch: Partial<UiState>) => {
  state = { ...state, ...patch };
  for (const l of listeners) l();
};

export const openAuth = (mode: 'signup' | 'login' = 'signup', reason?: string) => set({ auth: { mode, reason } });
export const closeAuth = () => set({ auth: null });
export const openSettings = () => set({ settings: true });
export const closeSettings = () => set({ settings: false });

export function useUi(): UiState {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
  );
}
